export default __webpack_public_path__ + "static/media/dalenhand_thumb.80bb32a7.jpg";